import { render, staticRenderFns } from "./procedure-header.vue?vue&type=template&id=2f7ef426&"
import script from "./procedure-header.vue?vue&type=script&lang=js&"
export * from "./procedure-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports